import { useMemo } from 'react'

import { useScreen } from '@/store/screen'

export const useCaseConclusion = () => {
  const { windowSize } = useScreen()

  const fontSizesByScreenSize = useMemo(() => {
    const fontsSizesByScreen = {
      1440: {
        title: 'h3' as const,
        description: 'b2' as const,
        topicTitle: 'b2' as const,
        subTopicTitle: 'b3' as const,
      },
      700: {
        title: 'b2' as const,
        description: 'b3' as const,
        topicTitle: 'b3' as const,
        subTopicTitle: 'b4' as const,
      },
    }
    return fontsSizesByScreen
  }, [])

  const { width } = windowSize
  const fontSizes = useMemo(() => {
    if (!width) return fontSizesByScreenSize[1440]
    if (width <= 700) return fontSizesByScreenSize[700]
    return fontSizesByScreenSize[1440]
  }, [width, fontSizesByScreenSize])

  const separateStars = (score: number) => {
    const starScoresArray = []
    let starPercentage = score
    for (let i = 1; i <= 5; i += 1)
      if (starPercentage >= 1) {
        starPercentage -= 1
        starScoresArray.push(100)
      } else {
        starScoresArray.push(Number(starPercentage.toFixed(1)) * 100)
        starPercentage = 0
      }
    return starScoresArray
  }

  return {
    separateStars,
    fontSizes,
  }
}
